'use strict';

/**
 * Allows only pro values for promo storefront field
 */
function handlePromoStorefrontValue(value) {
    var allowedValues = ['PRO10', 'PRO30', 'PRO40', 'PRO50', 'LIMITED EDITION', 'PRO LIMITED'];
    if (!allowedValues.includes(value)) return null;
    
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
}

function capitalizeFirstLetter(value) {
    if (typeof value !== 'string' || value.length === 0) return value;
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
}

module.exports = {
    handlePromoStorefrontValue: handlePromoStorefrontValue,
    capitalizeFirstLetter: capitalizeFirstLetter
};
